import { createSelector } from 'reselect';

import { BaggageType, GdsServiceVipSubType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { CheckoutState } from '../reducers';
import { LoadingServiceType, LoadingServicesParamsState } from './reducers';

import { getIsLoadingServiceByParams as getIsLoadingServiceByParamsUtil } from '../../../utils';

export const getLoadingServiceTypesState = (state: CheckoutState) => state.loadingServiceParams;

export const getIsLoadingServiceByParams = (
	params: {
		id?: string;
		rfisc?: string;
		subType?: BaggageType | GdsServiceVipSubType;
		type?: OrderAdditionalServiceGdsServiceServiceType | LoadingServiceType;
	},
	loadingParamKeys: (keyof LoadingServicesParamsState)[] = ['subType', 'type']
) =>
	createSelector(getLoadingServiceTypesState, loadingServicesTypesState =>
		getIsLoadingServiceByParamsUtil(loadingServicesTypesState, params, loadingParamKeys)
	);
